var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBattery = function SvgBattery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Ebene 1",
    viewBox: "0 0 50 50"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 31.15h19.13a2 2 0 0 0 1.42-.59L32.13 29a2 2 0 0 0 .58-1.42v-7.73a1 1 0 0 0-1-1H10a1 1 0 0 0-1 1v10.3a1 1 0 0 0 1 1m1.3-10h19.12v6.7a1 1 0 0 1-1 1H11.34z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.65 19.44h-2.94v-4.53a1 1 0 0 0-1-1H6.93a2 2 0 0 0-1.42.59l-1.58 1.58a2 2 0 0 0-.58 1.42v17.59a1 1 0 0 0 1 1h37.36a1 1 0 0 0 1-1v-4.53h2.94a1 1 0 0 0 1-1v-9.12a1 1 0 0 0-1-1m-5.24 14.35H5.65V17.21a1 1 0 0 1 1-1h33.76v14.35zm3.94-5.53h-1.64v-6.52h1.64z"
  })));
};
export default SvgBattery;